export const DEFAULT_CDN_URL = "https://cdn.dial-once.com";
export const dialonceLogoUrl = `${DEFAULT_CDN_URL}/img/dialonce/crai/logo.svg`;
export const dialonceSmallLogoUrl = `${DEFAULT_CDN_URL}/img/dialonce/crai/logo-small.svg`;
